import { AlertCircle } from "lucide-react";
import type { InstallmentSeries } from "@/hooks/useInstallments";
import { InstallmentRow } from "./InstallmentRow";
import {
  Table,
  TableHeader,
  TableBody,
  TableHead,
  TableRow,
} from "@/components/ui/table";
import { Card, CardContent } from "@/components/ui/card";

interface InstallmentsListProps {
  series: InstallmentSeries[];
  onSeriesClick?: (series: InstallmentSeries) => void;
  isLoading?: boolean;
}

export function InstallmentsList({ series, onSeriesClick, isLoading }: InstallmentsListProps) {
  if (isLoading) {
    return (
      <Card>
        <CardContent className="p-6">
          <div className="space-y-4">
            {[1, 2, 3, 4, 5].map((i) => (
              <div
                key={i}
                className="h-16 bg-secondary/30 rounded-lg animate-pulse"
              />
            ))}
          </div>
        </CardContent>
      </Card>
    );
  }

  if (series.length === 0) {
    return (
      <Card>
        <CardContent className="flex flex-col items-center justify-center py-12">
          <AlertCircle className="h-12 w-12 text-muted-foreground mb-4" />
          <h3 className="text-lg font-medium">Nenhuma transação parcelada encontrada</h3>
          <p className="text-sm text-muted-foreground mt-1 text-center">
            Crie transações parceladas através do formulário de transações
          </p>
        </CardContent>
      </Card>
    );
  }

  return (
    <Card>
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>Descrição</TableHead>
            <TableHead>Tipo</TableHead>
            <TableHead className="text-right">Valor Total</TableHead>
            <TableHead className="text-right">Por Parcela</TableHead>
            <TableHead>Progresso</TableHead>
            <TableHead>Datas</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {series.map((s) => (
            <InstallmentRow
              key={s.id}
              series={s}
              onClick={() => onSeriesClick?.(s)}
            />
          ))}
        </TableBody>
      </Table>
    </Card>
  );
}
